// extracted by mini-css-extract-plugin
export var isActive = "utils-__Styles-module___isActive";
export var isSuspended = "utils-__Styles-module___isSuspended";